"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _MemberLabelTablePane = _interopRequireDefault(require("./member_label/MemberLabelTablePane.vue"));
var _MemberListByLabel = _interopRequireDefault(require("./member_label/MemberListByLabel.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '会员标签',
  components: {
    MemberLabelTablePane: _MemberLabelTablePane.default,
    MemberListByLabel: _MemberListByLabel.default
  },
  data: function data() {
    return {
      activeName: 'member_label_table',
      memberListTabs: [],
      // 会员列表标签页数组
      tabIndex: 0 // 标签页索引
    };
  },
  created: function created() {},
  methods: {
    /**
     * 处理打开会员列表tab事件
     * @param {Object} labelData - 标签数据
     */
    handleOpenMemberListTab: function handleOpenMemberListTab(labelData) {
      // 生成新的标签页名称
      var newTabName = "member-list-".concat(++this.tabIndex);

      // 检查是否已经存在相同标签的tab
      var existingTab = this.memberListTabs.find(function (tab) {
        return tab.labelId === labelData.fnId;
      });
      if (existingTab) {
        // 如果已存在，则激活该tab
        this.activeName = existingTab.name;
        return;
      }

      // 添加新的标签页
      this.memberListTabs.push({
        title: "\u4F1A\u5458\u5217\u8868 - ".concat(labelData.labelName),
        name: newTabName,
        labelId: labelData.fnId,
        labelData: labelData
      });

      // 激活新创建的tab
      this.activeName = newTabName;
    },
    /**
     * 处理标签页关闭事件
     * @param {String} targetName - 要关闭的标签页名称
     */
    handleTabRemove: function handleTabRemove(targetName) {
      // 不能关闭主标签页（会员标签列表）
      if (targetName === 'member_label_table') {
        return;
      }

      // 从memberListTabs数组中移除对应的标签页
      this.memberListTabs = this.memberListTabs.filter(function (tab) {
        return tab.name !== targetName;
      });

      // 如果关闭的是当前激活的标签页，则切换到主标签页
      if (this.activeName === targetName) {
        this.activeName = 'member_label_table';
      }
    }
  }
};